import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import {
  SearchInputComponent,
  SelectInputComponent,
} from "../../../common/components";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import { CampaignFilterProps } from "./campaign-filter-props";
import { actionsOptions } from "./campaign-filter-constant";
import "./campaign-filter.scss";
import { useNavigate } from "react-router-dom";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";
import { useLogin } from "../../../common/hooks/useUser";
import { useMediaQuery } from "@mui/material";

const CampaignFilter: React.FC<CampaignFilterProps> = (props: any) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    selectedLeadsFilter,
    selectedActions,
    setSelectedActions,
    onSearch,
    disabled,
    disableSelectedLeads,
    selectOpen,
    setSelectOpen,
    handleActionTrigger,
    searchRef,
    totalCampaigns,
  } = props;
  const [isResetSearch, setIsResetSearch] = useState<boolean>(false);
  const navigate = useNavigate();
  const { canRead, canWrite, canDelete } = useResourcePermissions(
    MODULES.VIEW_CAMPAIGNS
  );

  const {canExport} = useResourcePermissions(MODULES.EXPORT);
  const userDetails = useLogin();
  const isMobile = useMediaQuery("(max-width:768px)");

  const handleOpen = () => {
    setSelectOpen(true);
  };
  const handleBlur = () => {
    setSelectOpen(false);
  };
  const userRole = userDetails.userDetails.roles.role;
  const filteredActionsOptions = actionsOptions.filter((option) => {
    if (!canExport && option.value === "Export Campaigns") {
      return false;
    }

    if (option.value === "Archive" && !canDelete) {
      return false;
    }
    if (option.value !== "Archive" && !canWrite) return false;
    return true;
  });

  return (
    <div className="campaign-list-search-filter-wrapper">
      <div className="campaign-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Campaign name, Campaign owner"
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div className="campaign-list-filter-wrapper">
        <div
          className="campaign-list-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge
              color="secondary"
              badgeContent={selectedLeadsFilter?.length}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#887952",
                },
              }}
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
        {(canDelete || canWrite || userRole === "Super Admin") && (
          <div className="campaign-list-action-filter">
            <SelectInputComponent
              fieldName={"actions"}
              value={[selectedActions || "Actions"]}
              multiple={false}
              options={filteredActionsOptions}
              setSelectedActions={setSelectedActions}
              handleActionTrigger={handleActionTrigger}
              disableSelectedLeads={disableSelectedLeads}
              selectOpen={selectOpen}
              handleOpen={handleOpen}
              handleBlur={handleBlur}
              disabled={disabled}
              totalCampaigns={totalCampaigns}
              massActionsFor={"campaigns"}
              isEmailConfigured={userDetails?.isEmailConfigured}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignFilter;
